enum UsuarioGrupoTipoEnum {
  EntidadeSistema = 1,
  Transportadora = 2,
}

export default UsuarioGrupoTipoEnum
